import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import OrderQueueCard from "../../OrderQueueCard/OrderQueueCard.tsx";
import "./OrderItemModal.css";

const OrderItemModal = ({ orderDetails, reload, from }) => {
  const formatTime = (dateTimeString) => {
    if (dateTimeString) {
      const normalizedDateTimeString = dateTimeString.replace(/\.\d+/, "");

      const dateObject = new Date(normalizedDateTimeString);

      if (isNaN(dateObject)) {
        return "Invalid Date";
      }

      const timeOnly = dateObject.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return timeOnly;
    } else {
      return "N/A";
    }
  };
  const getLastFourDigits = (id) => {
    const orderId = id.toString();
    return `${orderId.slice(-6)}`;
  };
  return (
    <Box p={3}>
      <div className=" mt-2 " style={{ height: "20%" }}>
        <Typography variant="h5" className="orderQueueCardTitle">
          #Order {getLastFourDigits(orderDetails.id)}
        </Typography>
      </div>

      <Grid container spacing={2}>
        {orderDetails?.kitchenViews?.length > 0 &&
          orderDetails?.kitchenViews?.map((food, index) => (
            <>
              <Card>
                <CardContent>
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography className="orderQueueCardTableNo">
                      {food.kitchenName}
                    </Typography>
                    <div
                      className="d-flex justify-content-between  pt-1 align-items-center"
                      style={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Chip
                        label={orderDetails.toStatusData}
                        className="preparing-status"
                      />
                      <Typography sx={{ color: "#56595B" }}>
                        {formatTime(orderDetails?.creationDate)}
                      </Typography>
                    </div>
                  </div>
                  {food.subOrders.map((subOrder, i) => {
                    const itemsToShow = subOrder.orderItemDetailViews;

                    return (
                      <>
                        <Grid item xs={12} md={12}>
                          <div key={i}>
                            <div
                              className="OrderItemsDiv"
                              //   onDoubleClick={() => {
                              //     handleOrderStatusChange(order[0]?.id, 6, 5);
                              //   }}
                            >
                              <hr className="pt-0 mt-1 w-100" />
                              <div
                                className="d-flex"
                                style={{
                                  flexDirection: "row",
                                  justifyContent: "end",
                                }}
                              >
                                <Chip
                                  label={subOrder.orderTypeDetails}
                                  className="delivery"
                                />
                              </div>
                              {itemsToShow.map((item, i) => {
                                return (
                                  <>
                                    <React.Fragment key={i}>
                                      <OrderQueueCard
                                        ItemDetails={item}
                                        from={orderDetails.toStatusData}
                                        //   handleOrderStatusChange={
                                        //     handleOrderStatusChange
                                        //   }
                                        reload={reload}
                                        index={i}
                                        fromData={from}
                                      />
                                      <hr className="pt-0 mt-1 w-100" />
                                    </React.Fragment>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </Grid>
                      </>
                    );
                  })}
                </CardContent>
              </Card>
            </>
          ))}
      </Grid>
    </Box>
  );
};

export default OrderItemModal;
